import { render, staticRenderFns } from "./LocalPaymentsReview.vue?vue&type=template&id=39885752"
import script from "./LocalPaymentsReview.vue?vue&type=script&lang=js"
export * from "./LocalPaymentsReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports